import { render, staticRenderFns } from "./BorrowableTagBadge.vue?vue&type=template&id=07a77d06&scoped=true"
import script from "./BorrowableTagBadge.vue?vue&type=script&lang=js"
export * from "./BorrowableTagBadge.vue?vue&type=script&lang=js"
import style0 from "./BorrowableTagBadge.vue?vue&type=style&index=0&id=07a77d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a77d06",
  null
  
)

export default component.exports